<template>
    <div id="container">
        <object id="Player" style="width: 100%; height: 100%;" classid="CLSID:57EEB0DA-56B9-4C71-8A17-BE373C092DD5"
                :codebase="playerConfig.cap_file_path + '#version=' + playerConfig.player_version">
            <param name="IMAGEURL" :value="playerConfig.skin_path" />
            <param name="IMAGESHA1SUM" :value="playerConfig.skin_sha1sum" />
            <param name="DUPICATE" :value="(playerConfig.duplicate) ? 'TRUE' : 'FALSE'" />
            <param name="MEDIAINFO" :value="'media_info://' + mediaInfoString" />
        </object>
    </div>
</template>

<script>
import loadJsCss from 'load-js-css';
import vgControllerLoader from '../vgControllerLoader';

export default {
    name: 'kollus-player-v2',
    props: {
        playerPolicy: {
            type: Object,
            required: true,
        },
        mediaInfoString: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            playerConfig: this.playerPolicy.player_config.v2,
        };
    },
    beforeMount() {
        loadJsCss.list(this.playerConfig.resources);
    },
    mounted() {
        vgControllerLoader.load('v2', 'Player').then((controllee) => {
            try {
                // player 이벤트 핸들러 function을 윈도우 전역객체에 할당
                Kollus.Utility.merge_object(window, controllee.player_event_listeners());

                // postmessage를 통해 전달받은 플레이어 제어 명령 핸들러 등록
                controllee.init();
            } catch(e) {
                // 발생 가능한 예외
                // 1. PostMessage 사용 불가
            }
        });
    },
};
</script>

<style scoped>

</style>